import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

@Pipe({
  name: 'utcToLocalDate',
  standalone: true,
})
export class UtcToLocalDatePipe implements PipeTransform {
  transform(value: string | Date): string {
    if (!value) {
      return '';
    }
    const UTC_DATE = new Date(value);
    const LOCAL_DATE = new Date(
      UTC_DATE.getUTCFullYear(),
      UTC_DATE.getUTCMonth(),
      UTC_DATE.getUTCDate(),
      UTC_DATE.getUTCHours(),
      UTC_DATE.getUTCMinutes(),
      UTC_DATE.getUTCSeconds()
    );
    return new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).format(LOCAL_DATE);
  }
}
